import type React from "react";
import { createUseStyles } from "react-jss";

import SignedInBlock from "@/base/components/LoyaltyClub/SignedInBlock";
import config from "@/constants/config";
import { useAppSelector } from "@/store/hooks";
import { selectIsAuthenticated } from "@/store/user";

import { UserLogin } from "./UserLogin";

type BurgerMenuUserProps = {
  onClick?: () => void;
};

const useStyles = createUseStyles(({ spacing }) => ({
  signedInBlockContainer: {
    padding: [spacing.l, spacing.s],
  },
}));

export const BurgerMenuUser: React.FC<BurgerMenuUserProps> = ({ onClick }) => {
  const isAuthenticated = useAppSelector(selectIsAuthenticated);
  const classes = useStyles();

  if (!config.featureFlags.isLoginEnabled) {
    return null;
  }

  if (isAuthenticated) {
    return (
      <div className={classes.signedInBlockContainer}>
        <SignedInBlock variant="ghost" />
      </div>
    );
  }

  return <UserLogin onClick={onClick} />;
};
